import { Badge, BadgeType } from "components"
import { BookingStatusMap } from "utils/interfaces"
import { StatusText } from "modules/PsychologistAccount/BookingDetails/BookingStatus"
import { BookingStatusBadgeProps } from "modules/PsychologistAccount/BookingDetails/BookingDetails/interfaces"
import { GetBookingDetailsResponse } from "modules/BookingCommon/common/interfaces"

export function BookingStatusBadge({ status }: BookingStatusBadgeProps) {
    const badgeTypes = {
        [BookingStatusMap.PAID]: BadgeType.SUCCESS,
        [BookingStatusMap.NOT_PAID]: BadgeType.WARNING,
        [BookingStatusMap.PAY_STARTED]: BadgeType.SUCCESS,
        [BookingStatusMap.CANCELLED]: BadgeType.ERROR,
        [BookingStatusMap.CANCELLED_AFTER_PAYMENT]: BadgeType.ERROR,
        [BookingStatusMap.CANCELLED_WITHOUT_REFUND]: BadgeType.ERROR,
        [BookingStatusMap.PAID_AFTER_CANCELLATION]: BadgeType.SUCCESS,
        [BookingStatusMap.PAY_ERROR]: BadgeType.ERROR,
    }

    return <Badge type={badgeTypes[status]}>{StatusText[status]}</Badge>
}

export function refundIsImpossibleAlert(booking: GetBookingDetailsResponse) {
    if (booking.is_free) {
        return (
            <>
                До&nbsp;начала сессии менее 24&nbsp;часов. По&nbsp;правилам Alter бесплатную сессию
                можно перенести не&nbsp;позднее чем за&nbsp;24&nbsp;часа до&nbsp;начала.
            </>
        )
    }

    if (booking.discounted !== null && booking.price > 0) {
        return (
            <>
                До&nbsp;начала сессии менее 24&nbsp;часов. По&nbsp;правилам Alter при отмене или
                переносе сессии деньги не&nbsp;возвращаются, скидка аннулируется.
            </>
        )
    }

    if (booking.discounted !== null && booking.price === 0) {
        return (
            <>
                До&nbsp;начала сессии менее 24&nbsp;часов. По&nbsp;правилам Alter при отмене или
                переносе сессии скидка аннулируется.
            </>
        )
    }

    return (
        <>
            До&nbsp;начала сессии менее 24&nbsp;часов. По&nbsp;правилам Alter при отмене или
            переносе сессии деньги не&nbsp;возвращаются.
        </>
    )
}
